// Robot Module - Components
import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import {
  SmartToy as RobotIcon,
  CheckCircle as OnlineIcon,
  Warning as BusyIcon,
  BatteryChargingFull as ChargingIcon,
  Error as OfflineIcon,
} from '@mui/icons-material';
import { RobotStats } from '../types';

interface RobotStatsCardsProps {
  stats: RobotStats;
}

export const RobotStatsCards: React.FC<RobotStatsCardsProps> = ({ stats }) => {
  const statItems = [
    {
      label: 'Total',
      value: stats.total,
      icon: <RobotIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
      color: 'primary.main',
    },
    {
      label: 'Online',
      value: stats.online,
      icon: <OnlineIcon sx={{ fontSize: 40, color: 'success.main' }} />,
      color: 'success.main',
    },
    {
      label: 'Busy',
      value: stats.busy,
      icon: <BusyIcon sx={{ fontSize: 40, color: 'warning.main' }} />,
      color: 'warning.main',
    },
    {
      label: 'Charging',
      value: stats.charging,
      icon: <ChargingIcon sx={{ fontSize: 40, color: 'info.main' }} />,
      color: 'info.main',
    },
    {
      label: 'Offline',
      value: stats.offline,
      icon: <OfflineIcon sx={{ fontSize: 40, color: 'error.main' }} />,
      color: 'error.main',
    },
  ];

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
      {statItems.map(item => (
        <Card key={item.label} sx={{ flex: '1 1 200px', minWidth: '200px' }}>
          <CardContent sx={{ textAlign: 'center' }}>
            {item.icon}
            <Typography variant="h4" component="div" sx={{ color: item.color }}>
              {item.value}
            </Typography>
            <Typography color="text.secondary">{item.label}</Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};
